import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { audienceService } from '../services';
import LoadingSpinner from '../components/LoadingSpinner';

/**
 * Where a DNS host sends the owner back after the Domain Connect approval
 * (`/domain-connected?state=…&error=…`). `state` is ours: "ownerType|ownerId|returnPath",
 * base64url. Checks the domain once so the builder opens on the new status, then goes back.
 */
export function decodeDomainState(state) {
  try {
    const b64 = String(state || '').replace(/-/g, '+').replace(/_/g, '/');
    const [ownerType, ownerId, path] = atob(b64 + '==='.slice((b64.length + 3) % 4)).split('|');
    if (!['club', 'pro'].includes(ownerType) || !/^[0-9a-f-]{36}$/i.test(ownerId || '')) return null;
    return { ownerType, ownerId, path: path && path.startsWith('/') && !path.startsWith('//') ? path : '/' };
  } catch { return null; }
}

export default function DomainConnectedPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [line, setLine] = useState('Checking your domain…');
  useEffect(() => {
    const s = decodeDomainState(params.get('state'));
    if (!s) { setLine('That link has nothing to finish. Head back to your page.'); return undefined; }
    const err = params.get('error');
    let live = true;
    (async () => {
      if (err) setLine(err === 'access_denied' ? 'Nothing was changed. You can copy the records instead.' : 'Your DNS host couldn’t add the records. You can copy them instead.');
      else {
        const r = await audienceService.broadcastClient(s.ownerType, s.ownerId).checkDomain();
        if (!live) return;
        setLine(r?.data?.status === 'verified' ? 'Connected. Your page’s email now goes out from your domain.' : 'Records added. They can take a few minutes to go live; we’ll switch over by ourselves.');
      }
      setTimeout(() => { if (live) navigate(s.path, { replace: true }); }, 2200);
    })();
    return () => { live = false; };
  }, [params, navigate]);
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-[#F5F5F5] px-6 text-center font-mono" style={{ gap: 18 }}>
      <LoadingSpinner />
      <p style={{ fontSize: 13, lineHeight: 1.7, maxWidth: 420 }} data-testid="domain-connected-line">{line}</p>
    </div>
  );
}
